import { PropsWithoutRef } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { SIDEBAR_WIDTH } from "../constants";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <a
          href="/dashboard"
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard");
          }}
          className="logo_link"
        >
          <figure>
            <img src="/static/images/tiffxlogo.png" alt="Tiffx Logo" />
            {/* <figcaption>Barber Shop</figcaption>
            <figcaption className="logo_sm">BS</figcaption> */}
          </figure>
        </a>

        <IconButton
          sx={{
            display: "none",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={handleSidebarToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <Tooltip title="Dashboard" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/dashboard"}
            onClick={() => navigate("/dashboard")}
          >
            <ListItemIcon>
              <img src="/static/images/dashboard_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Dashboard" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Users" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-users" ||
              location.pathname === "/manage-users/edit" ||
              location.pathname === "/manage-users/detail"
            }
            onClick={() => navigate("/manage-users")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Users" />
          </ListItemButton>
        </Tooltip>

        {/* Workout management */}

        <Tooltip
          title="Workout management
"
          placement="right"
        >
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-workout" ||
              location.pathname === "/manage-workout/edit" ||
              location.pathname === "/manage-workout/detail"
            }
            onClick={() => navigate("/manage-workout")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Workout management
"
            />
          </ListItemButton>
        </Tooltip>

        {/* Manage Programs */}

        <Tooltip title="Manage Programs" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-programs" ||
              location.pathname === "/manage-programs/edit" ||
              location.pathname === "/manage-programs/detail"
            }
            onClick={() => navigate("/manage-programs")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Programs" />
          </ListItemButton>
        </Tooltip>

        {/* subscription */}

        <Tooltip title="Subscription" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/subscription" ||
              location.pathname === "/subscription/edit" ||
              location.pathname === "/subscription/detail"
            }
            onClick={() => navigate("/subscription")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Subscription" />
          </ListItemButton>
        </Tooltip>

        {/* Achievements & Badges */}

        <Tooltip title="Achievements & Badges " placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/achievements"}
            onClick={() => navigate("/achievements")}
          >
            <ListItemIcon>
              <img src="/static/images/rating.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Achievements & Badges "
            />
          </ListItemButton>
        </Tooltip>

        {/* category */}
        <Tooltip title="Categories" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-categories" ||
              location.pathname ===
                "/manage-categories/manage-sub-categories" ||
              location.pathname === "/manage-categories/manage-attributes"
            }
            onClick={() => navigate("/manage-categories")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Categories" />
          </ListItemButton>
        </Tooltip>

        {/* Revenue Generation */}

        
        <Tooltip title="Revenue Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-transactions" 
            }
            onClick={() => navigate("/manage-transactions")}
          >
            <ListItemIcon>
              <img src="/static/images/revenue.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Revenue Management" />
          </ListItemButton>
        </Tooltip>

        {/* <Tooltip title="Manage Ready Made Yoghurts" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-readymade-yoghurt" ||
              location.pathname === "/manage-readymade-yoghurt/add" ||
              location.pathname === "/manage-readymade-yoghurt/detail"
            }
            onClick={() => navigate("/manage-readymade-yoghurt")}
          >
            <ListItemIcon>
              <img src="/static/images/yogurt.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Ready Made Yoghurts"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Manage Stores" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-stores"||
              location.pathname === "/manage-stores/add"||
              location.pathname === "/manage-stores/view"
            }
            onClick={() => navigate("/manage-stores")}>
            <ListItemIcon>
              <img src="/static/images/store_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Stores"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Order Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-order" 
            }
            onClick={() => navigate("/manage-order")}
          >
            <ListItemIcon>
              <img src="/static/images/order.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Order Management" />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Mange Yogurt Types" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-yogurt-types" ||
              location.pathname === "/manage-yogurt-types/detail"
            }
            onClick={() => navigate("/manage-yogurt-types")}
          >
            <ListItemIcon>
              <img src="/static/images/yogurt_type_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Mange Yogurt Types"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Manage Toppings" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-toppings"            
            }
            onClick={() => navigate("/manage-toppings")}
          >
            <ListItemIcon>
              <img src="/static/images/topping.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Toppings" />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Mange Flavors" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-flavour" ||
              location.pathname === "/manage-flavour/quantity"
            }
            onClick={() => navigate("/manage-flavour")}
          >
            <ListItemIcon>
              <img src="/static/images/flavor.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Mange Flavors"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Manage Product Categories" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-product-categories"            
            }
            onClick={() => navigate("/manage-product-categories")}
          >
            <ListItemIcon>
              <img src="/static/images/topping.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Product Categories" />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Mange Products" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-products" ||
              location.pathname === "/manage-products/detail"
            }
            onClick={() => navigate("/manage-products")}
          >
            <ListItemIcon>
              <img src="/static/images/flavor_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Mange Products"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Manage Box Art" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-box-art"
            }
            onClick={() => navigate("/manage-box-art")}
          >
            <ListItemIcon>
              <img src="/static/images/box_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Box Art"
            />
          </ListItemButton>
        </Tooltip> */}

        {/* <Tooltip title="Manage Greek Box" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-greek-box"
            }
            onClick={() => navigate("/manage-greek-box")}
          >
            <ListItemIcon>
              <img src="/static/images/box_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Greek Box"
            />
          </ListItemButton>
        </Tooltip>
         */}
        {/* <Tooltip title="Manage loyalty points" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-loyality-points" ||
              location.pathname === "/manage-loyality-points/add"
           
            }
            onClick={() => navigate("/manage-loyality-points")}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage loyalty points"
            />
          </ListItemButton>
        </Tooltip> */}
        <Tooltip title="Discounts and Coupons" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/discounts" ||
              location.pathname === "/discounts/add"
            }
            onClick={() => navigate("/discounts")}
          >
            <ListItemIcon>
              <img src="/static/images/offer_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Discounts and Coupons"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Notification Management" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-notifications" ||
              location.pathname === "/manage-notifications/add" ||
              location.pathname === "/manage-notifications/detail"
            }
            onClick={() => navigate("/manage-notifications")}
          >
            <ListItemIcon>
              <img src="/static/images/logs_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Notification Management"
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Report Analytics" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/revenue-analytic"}
            onClick={() => navigate("/revenue-analytic")}
          >
            <ListItemIcon>
              <img src="/static/images/report_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Report Analytics" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Manage Sub-admin" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-subadmin" ||
              location.pathname === "/manage-subadmin/add" ||
              location.pathname === "/manage-subadmin/detail" ||
              location.pathname === "/manage-subadmin/roles" ||
              location.pathname === "/manage-subadmin/roles/add" ||
              location.pathname === "/manage-subadmin/roles/detail"
            }
            onClick={() => navigate("/manage-subadmin")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Sub-admin" />
          </ListItemButton>
        </Tooltip>

        {/* Community Moderation */}

        <Tooltip title="Community Moderation " placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/Community"}
            onClick={() => navigate("/Community")}
          >
            <ListItemIcon>
              <img src="/static/images/rating.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Community Moderation "
            />
          </ListItemButton>
        </Tooltip>

        {/* <Tooltip title="Manage Ratings & Reviews" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={
              location.pathname === "/manage-ratings"
            }
            onClick={() => navigate("/manage-ratings")}
          >
            <ListItemIcon>
              <img src="/static/images/rating.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage Ratings & Reviews" />
          </ListItemButton>
        </Tooltip> */}

        <Tooltip title="Manage CMS Pages" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/manage-cms"}
            onClick={() => navigate("/manage-cms")}
          >
            <ListItemIcon>
              <img src="/static/images/cms_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Manage CMS Pages" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Settings" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/settings"}
            onClick={() => navigate("/settings")}
          >
            <ListItemIcon>
              <img src="/static/images/cms_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Settings" />
          </ListItemButton>
        </Tooltip>
        {/* <Tooltip title="Manage Customer Support" placement="right">
          <ListItemButton
            className="lst-itm"
            selected={location.pathname === "/customer-support"}
            onClick={() => navigate("/customer-support")}
          >
            <ListItemIcon>
              <img src="/static/images/user_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText
              className="lstitm-txt"
              primary="Manage Customer Support"
            />
          </ListItemButton>
        </Tooltip> */}
      </List>
    </>
  );
  return (
    <Box
      component="nav"
      sx={{
        width: mobileOpen ? SIDEBAR_WIDTH : 0,
        transition: "width 0.3s",
        overflowX: "hidden",
      }}
      className={mobileOpen ? "sidebar-main-div active" : "sidebar-main-div"}
    >
      <Drawer
        className="sidebar_drawer"
        variant="persistent"
        sx={{
          // display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
      {/* <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer> */}
    </Box>
  );
}
